"use client";

import { Button } from "@heroui/react";
import { useTheme } from "next-themes";

/*
 * The icons swap in CSS rather than from React state. next-themes writes the
 * theme class onto <html> before paint, so `dark:` handles this with no mount
 * flag, no hydration mismatch, and no cascading render — HeroUI redefines the
 * `dark` variant as class-first with a system fallback, so it tracks
 * next-themes' class strategy directly.
 */

const SunIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" className="hidden size-4 dark:block" aria-hidden>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2m0 16v2M4.9 4.9l1.4 1.4m11.4 11.4 1.4 1.4M2 12h2m16 0h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" strokeLinecap="round" />
  </svg>
);

const MoonIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" className="size-4 dark:hidden" aria-hidden>
    <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z" strokeLinejoin="round" />
  </svg>
);

export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();

  return (
    <Button
      isIconOnly
      variant="ghost"
      size="sm"
      aria-label="Toggle between light and dark theme"
      onPress={() => setTheme(resolvedTheme === "dark" ? "light" : "dark")}
    >
      <MoonIcon />
      <SunIcon />
    </Button>
  );
}
